import React, { useContext, useEffect, useState, useRef } from "react";
//import classes from "./pricingDropdowns.module.scss";
import classes from "../dashboardComponents/DashboardComponents.module.scss";
import { Col, Row } from "react-bootstrap";
import { OrgIdContext } from "../../store/orgId_context";
import { useTranslation } from "react-i18next";
import OutboxIcon from '@mui/icons-material/Outbox';
import MoveToInboxIcon from '@mui/icons-material/MoveToInbox';
import QrCodeIcon from '@mui/icons-material/QrCode';
import Button from "../UI/Button";
import { Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress, Checkbox } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { DDD, E2Data } from "../../lib/ddd/ddd";
import {Checkout} from "@fung-sdk/checkout"
import { NotificationManager} from 'react-notifications';
import PaymentIcon from '@mui/icons-material/Payment';
import GenericModal from "../UI/GenericModal";
import CurrencyTextField from '@lupus-ai/mui-currency-textfield'
import useInterval from "../../lib/useInterval";
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CardsSelect from "./CardsSelect";


const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
const ddd = new DDD(apiRequestAddress);

const Overview = ({goToPackages, goToMethods}) => {
    const {sessionInfo, setSessionInfoHandler} = useContext(OrgIdContext);
    const [IEIPackage, setIEIPackage] = useState();
    const [REIPackage, setREIPackage] = useState();
    const [fiscPackage, setFiscPackage] = useState();
    const [confirmDialog, setConfirmDialog] = useState();
    const [addCardLoading, setAddCardLoading] = useState();
    const [addFundsLoading, setAddFundsLoading] = useState();
    const [showPaymentModal, setShowPaymentModal] = useState();
    const [checkoutType, setCheckoutType] = useState();
    const [addFundsCheckoutStatus, setAddFundsCheckoutStatus] = useState();
    const [addUnscheduledCheckoutStatus, setAddUnscheduledCheckoutStatus] = useState();
    const [openedAddFunds, setOpenedAddFunds] = useState();
    const myElementRef = useRef(null);
    const [autoRecharge, setAutoRecharge] = useState(false);
    const [autoChargeData, setAutoChargeData] = useState();
    const [confirmAutoRecharge, setConfirmAutoRecharge] = useState();
    const [openAutoChargeform, setOpenAutoChargeform] = useState();
    const [recurringValue, setRecurringValue] = useState();
    const [recurringLoading, setRecurringLoading] = useState();
    const [recurringPrepay, setRecurringPrepay] = useState(true);
    const [error, setError] = useState();
    const [success, setSuccess] = useState();
    const [value, setValue] = useState(0);
    const [waitingForAuto, setWaitingForAuto] = useState();
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("Saved"); //Saved, New
    const [showSavedPaymentsWindow, setShowSavedPaymentsWindow] = useState();
    const [savedLoading, setSavedLoading] = useState();
    const [savedValue, setSavedValue] = useState();
    const [savedCardSelected, setSavedCardSelected] = useState();
    const [showNewPaymentWindow, setShowNewPaymentWindow] = useState();
    const {t} = useTranslation();
    /* const [mode, setMode] = useState("production"); //sandbox, production */
    const [mode, setMode] = useState(() => {
        const hostname = window.location.hostname;
        return hostname.includes('dev.') || hostname === 'localhost' ? 'sandbox' : 'production';
    });

    const {isPending , data, refetch } = useQuery({
        queryKey: ["EUeInvoices.GetPaymentMethods", "payments"],
        queryFn: () => ddd.Rpc_ExecuteExtension("EUeInvoices.GetPaymentMethods", {})
    })

    useEffect(() => {
        const url = window.location.href;
        if(!url) return;
        if (url.startsWith("http://dev.") || url.includes("localhost")) {
            setMode("sandbox");
        }
    }, []);
    
    useEffect(() => {
        setIEIPackage(sessionInfo?.Extended?.CurrentPackages?.IEI_Package)
        setREIPackage(sessionInfo?.Extended?.CurrentPackages?.REI_Package)
        setFiscPackage(sessionInfo?.Extended?.CurrentPackages?.FISC_Package)
    },[sessionInfo]);

    useEffect(() => {
        data?.result?.map((card, index) => {
            if(card.Recurring && card.RecurringActive){
                setAutoRecharge(true);
                setAutoChargeData(card);
                if(waitingForAuto){
                    setWaitingForAuto(false);
                    NotificationManager.success(t("Automatic recharge activated"), t("Success"), 5000);
                }
            }
        })
    }, [data, waitingForAuto]);

    useInterval(() => {
        refetchSessionData();
        refetch();
    }, 15000);

    const refetchSessionData = () => {
        ddd.InvalidateSessionExtensions().then(() => {
            ddd.GetSessionAuthDescribe({includeExtendedInfo: true}).then(res => {
                if(res?.result)
                    setSessionInfoHandler(res.result);
            });
        });
    }
    const cancelPackage = (p) => {
        setConfirmDialog(p);
    }

    const onCancelConfirm = () => {
        setConfirmDialog(null);
    }

    const onConfirmPackageChange = () => {
        setConfirmAutoRecharge(null);
    }

    const onCancelConfirmAuto = () => {
        setConfirmAutoRecharge(null);
    }

    const onConfirmChangeAuto = () => {
        if(!autoChargeData) return NotificationManager.error(t("An error occured. Please contact support."), t("Error"), 5000);
        setAutoRecharge(false);
        setAutoChargeData(null);
        const e2data = new E2Data("EU_FungCheckout");
        e2data.filter = `Id='${autoChargeData.Id}'`;
        e2data.values = {"RecurringActive": false};
        e2data.Modify().then(res => {
            refetch();
        });
        setConfirmAutoRecharge(null);
    }

    const onAutoRechargeClick = () => {
        if(waitingForAuto) return NotificationManager.error(t("Please wait for the current operation to finish"), t("Error"), 5000);
        if(autoRecharge){
            setConfirmAutoRecharge(true);
        }else{
            setOpenAutoChargeform(true);
        }
    }

    let _checkoutType = checkoutType;
    useEffect(() => {
        if(showPaymentModal){
            const checkout = new Checkout({
                checkoutId: showPaymentModal?.id,
                containerId: "paymentContainerModal",
                //env: "sandbox",
                env: mode,
            })
            checkout.on("checkout:loaded", (e) => {
                //console.log(e);
            })
    
            checkout.on("checkout:completed", (e) => {console.log(_checkoutType);
                checkout.removeAllListeners();
                switch(_checkoutType){
                    case "UnscheduledUpfront":
                    case "Unscheduled":
                        onUnscheduledCompleted(showPaymentModal?.id);
                        break;
                    case "AddFunds":
                        onAddFundsCompleted(showPaymentModal?.id);
                        break;
                    case "RecurringUpfront":
                    case "Recurring":
                        onRecurringCompleted(showPaymentModal?.id);
                        break;
                    default:
                        break;
                }
                clearIframeDiv();
                setShowPaymentModal(false);
            })
    
            checkout.on("checkout:invalid", (e) => {
                checkout.removeAllListeners();
                setErrorMsg(t("Payment was invalid"));
                clearIframeDiv();
                setShowPaymentModal(false);
            })
    
            checkout.on("checkout:failed", (e) => {
                checkout.removeAllListeners();
                setErrorMsg(t("Payment failed"));
                clearIframeDiv();
                setShowPaymentModal(false);
            })
            checkout.render();
        }
    }, [showPaymentModal]);

    const onAddFundsCompleted = (checkoutId) => {
        setOpenedAddFunds(false);
        setAddFundsCheckoutStatus(checkoutId);
    };
    const onUnscheduledCompleted = (checkoutId) => {
        refetch();
        setAddUnscheduledCheckoutStatus(checkoutId);
    };
    const onRecurringCompleted = (checkoutId) => {
        setWaitingForAuto(true);
        refetch();
    }

    const onAddPaymentCardClick = () => {
        setAddCardLoading(true);
        setCheckoutType("Unscheduled");
        ddd.Rpc_ExecuteExtension("EUeInvoices.CreateFungCheckout", {"Type": "Unscheduled"}).then(res => {
            setAddCardLoading(false);
            if(!res?.result?.id) return NotificationManager.error(t("Unable to create a new checkout"), t("Error"), 5000);
            setShowPaymentModal(res?.result);
        }).catch(err => {
            setAddCardLoading(false);
            setShowPaymentModal(false);
            NotificationManager.error(t("An unknown error occured"), t("Error"), 5000);
        });
    }

    const clearIframeDiv = () => {
        const container = document.getElementById("paymentContainerModal");
        if (container == null)return;

        container.innerHTML = null;
    }

    const onAddFundsClick = () => {
        if(!value || value <= 0) return setErrorMsg(t("Please enter a valid amount"));
        setCheckoutType("AddFunds");
        setAddFundsLoading(true);
        ddd.Rpc_ExecuteExtension("EUeInvoices.CreateFungCheckout", {"Type": "AddFunds", "Amount" : value*100}).then(res => {
            setAddFundsLoading(false);
            if(!res?.result?.id) return NotificationManager.error(t("Unable to create a new checkout"), t("Error"), 5000);
            setShowNewPaymentWindow(false);
            setShowPaymentModal(res?.result);
        }).catch(err => {
            setShowNewPaymentWindow(false);
            setShowPaymentModal(false);
            setAddFundsLoading(false);
            NotificationManager.error(t("An unknown error occured"), t("Error"), 5000);
        });
    }

    const onAddRecurringClick = () => {
        if(!recurringValue || recurringValue <= 0) return NotificationManager.error(t("Please enter a valid amount"), t("Error"), 5000);
        setRecurringLoading(true);
        setCheckoutType("Recurring");
        let type = recurringPrepay ? "ReccuringUpfront" : "Reccuring";
        ddd.Rpc_ExecuteExtension("EUeInvoices.CreateFungCheckout", {"Type": type, "Amount" : recurringValue*100}).then(res => {
            setRecurringLoading(false);
            setOpenAutoChargeform(false);
            if(!res?.result?.id) return NotificationManager.error(t("Unable to create a new checkout"), t("Error"), 5000);
            setShowPaymentModal(res?.result);
        }).catch(err => {
            setShowPaymentModal(false);
            setOpenAutoChargeform(false);
            setRecurringLoading(false);
            NotificationManager.error(t("An unknown error occured"), t("Error"), 5000);
        });
    }

    const onUnscheduledSavedClick = () =>{
        if(savedCardSelected.value === -1) return OnUnscheduledSavedUpfrontClick();
        if(!savedCardSelected)  return NotificationManager.error(t("Please select a card"), t("Error"), 5000);
        if(!savedValue || savedValue <= 0) return NotificationManager.error(t("Please enter a valid amount"), t("Error"), 5000);
        if(!savedCardSelected?.data?.CardDetails?.paymentContractId) return NotificationManager.error(t("An unknown error occured witht this card"), t("Error"), 5000);

        
        setSavedLoading(true);
        setShowSavedPaymentsWindow(false);
        let data ={
            "CheckoutId" : savedCardSelected?.data?.FungId,
            "Amount": savedValue*100,
            "Type" : "Unscheduled"
        }
        
        ddd.Rpc_ExecuteExtension("EUeInvoices.ChargeFungCheckout", data).then((res) => {
            setSavedLoading(false);
            setTimeout(() => refetchSessionData(), 4000);
            setSuccessMsg(
                <><div>{t("Payment was: ")}{res?.result?.status}</div><div className="fs-8">{t("It might take a few minutes for the funds to be available.")}</div></>);
        }).catch((err) => {
            setSavedLoading(false);
            setErrorMsg(t("An error occurred, please contact support."));
        });
    }

    const OnUnscheduledSavedUpfrontClick = () => {
        if(!savedCardSelected)  return NotificationManager.error(t("Please select a card"), t("Error"), 5000);
        if(!savedValue || savedValue <= 0) return NotificationManager.error(t("Please enter a valid amount"), t("Error"), 5000);

        setSavedLoading(true);
        setCheckoutType("UnscheduledUpfront");
        ddd.Rpc_ExecuteExtension("EUeInvoices.CreateFungCheckout", {"Type": "UnscheduledUpfront", "Amount" : savedValue*100}).then(res => {
            setSavedLoading(false);
            setShowSavedPaymentsWindow(false);
            if(!res?.result?.id) return NotificationManager.error(t("Unable to create a new checkout"), t("Error"), 5000);
            setShowPaymentModal(res?.result);
        }).catch(err => {
            setShowPaymentModal(false);
            setShowSavedPaymentsWindow(false);
            setSavedLoading(false);
            NotificationManager.error(t("An unknown error occured"), t("Error"), 5000);
        });
    }

    const onContinueClick = () =>{
        if(selectedPaymentMethod === "Saved"){
            setShowSavedPaymentsWindow(true);
        }else{
            setShowNewPaymentWindow(true);
        }
    }

    const setErrorMsg = (msg) => {
        setError(msg);
        setTimeout(() => {
            setError(null);
        }, 3000);
    }

    const setSuccessMsg = (msg) => {
        setSuccess(msg);
        setTimeout(() => {
            setSuccess(null);
        }, 10000);
    }

    const getFormattedAmount = (amount) => {
        try {
            return new Intl.NumberFormat('de-DE', { 
                style: 'currency', 
                currency: 'EUR' 
            }).format(amount);
        }catch(e){
            return amount;
        }
    }

    

    return (<>
        <Dialog
        sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }}
        maxWidth="xs"
        TransitionProps={{ }}
        open={confirmDialog}>
            <DialogTitle>{t("Confirm package change")}</DialogTitle>
            <DialogContent dividers>
            {t("Are you certain you wish to cancel package")}: {confirmDialog?.PackageCode}, {confirmDialog?.PayType}
            </DialogContent>
            <DialogActions>
                <Button className="ps-2 pe-2" autoFocus onClick={onCancelConfirm}>
                {t("Cancel")}
                </Button>
                <Button className="ps-2 pe-2" onClick={onConfirmPackageChange}>Ok</Button>
            </DialogActions>
        </Dialog>
        <Dialog
        sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }}
        maxWidth="xs"
        TransitionProps={{ }}
        open={confirmAutoRecharge}>
            <DialogTitle>{t("Stop auto recharge?")}</DialogTitle>
            <DialogContent dividers>
            {t("Your credit balance will stop being topped up automatically and you’ll have to manually recharge it.")}
            </DialogContent>
            <DialogActions>
                <Button className="ps-2 pe-2" autoFocus onClick={onCancelConfirmAuto}>
                {t("Cancel")}
                </Button>
                <Button className="ps-2 pe-2" onClick={onConfirmChangeAuto}>{t("Stop auto recharge")}</Button>
            </DialogActions>
        </Dialog>
        <Row>
            <Col className="col-12">
                <div className={classes.container} style={{maxHeight:"none"}}>
                    <h4>{t("Current packages")}</h4>
                    <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
                        {IEIPackage && <Package p={IEIPackage} title={t("Sent invoices")} goToPackages={goToPackages} cancelPackage={cancelPackage} icon={<OutboxIcon className="me-2"/>}/>}
                        {REIPackage && <Package p={REIPackage} title={t("Received invoices")} goToPackages={goToPackages} cancelPackage={cancelPackage} icon={<MoveToInboxIcon className="me-2"/>}/>}
                        {sessionInfo?.Extended?.IsFiscalization && fiscPackage && <Package p={fiscPackage} title={t("Fiscalization")} goToPackages={goToPackages} cancelPackage={cancelPackage} icon={<QrCodeIcon className="me-2"/>}/>}
                    </div>
                </div>
            </Col>
        </Row>
        <GenericModal show={showPaymentModal} onHide={() => setShowPaymentModal(false)} title="Add funds" icon={<PaymentIcon/>}>
            <div id="paymentContainerModal" style={{textAlign:"center"}} ref={myElementRef}></div>
        </GenericModal>
        <GenericModal show={openAutoChargeform} onHide={() => setOpenAutoChargeform(false)} title={t("Auto charge")} icon={<PaymentIcon/>} size="md">
            <div>
                <div className="fs-5 fw-bold text-center mb-2">{t("Auto recharge settings")}</div>
                <div className="fs-7 mb-1">{t("Yes, automatically recharge my credit balance, for specific amount each month.")}</div>
                <div className="fs-7 mb-3">{t("We recommend you to set-up the amount, equal or slightly higher than a payment plan for the expected amount of invoices each month.")}</div>
                <div>
                    <CurrencyTextField
                        label="Recharge my credit balance for amount per month"
                        variant="standard"
                        value={recurringValue}
                        currencySymbol="€"
                        disabled={recurringLoading}
                        //minimumValue="0"
                        outputFormat="string"
                        decimalCharacter="."
                        digitGroupSeparator=","
                        onChange={(event, value)=> setRecurringValue(value)}
                        style={{width:"100%"}}
                    />
                    
                </div>
                <div className="d-flex align-items-center"><Checkbox id="prepay" checked={recurringPrepay} size="small" onChange={(e) => setRecurringPrepay(e.target.checked)}/> <label className="fs-8" for="prepay">{t("Make first payment straight away")}</label></div>
                {recurringLoading && <LinearProgress sx={{
                            '& .MuiLinearProgress-bar': {
                            backgroundColor: '#005683',
                            },
                            backgroundColor: '#b1d1e1',
                        }}/>}
                <div className="text-end mt-2">
                    <Button disabled={recurringLoading} className="ps-2 pe-2 me-2" style={{fontSize:"1rem"}} onClick={() => setOpenAutoChargeform(false)}>{t("Cancel")}</Button>
                    <Button disabled={recurringLoading} className="ps-2 pe-2" style={{fontSize:"1rem"}} onClick={onAddRecurringClick}>{t("Activate")}</Button>
                </div>
            </div>
        </GenericModal>
        <GenericModal show={showSavedPaymentsWindow} onHide={() => setShowSavedPaymentsWindow(false)} title={t("Add credit to balance")} icon={<PaymentIcon/>} size="md">
            <div>
                <div className="fs-7 mb-1">{t("Choose among the saved payment methods.")}</div>
                <div>
                    <CardsSelect cards={data?.result} onValueChange={(e)=> {setSavedCardSelected(e);}} refetch={refetch}/>
                </div>
                {/* <div className={`text-end fs-7 fw-bold ${classes["hover-scale"]} text-success mt-1`} onClick={() => {setShowSavedPaymentsWindow(false);goToMethods();}}>
                    + {t("Add payment method")}
                </div> */}
                <div className="mb-2"></div>
                <div>
                    <CurrencyTextField
                        label="Amount to add"
                        variant="standard"
                        value={savedValue}
                        currencySymbol="€"
                        disabled={savedLoading}
                        //minimumValue="0"
                        outputFormat="string"
                        decimalCharacter="."
                        digitGroupSeparator=","
                        onChange={(event, value)=> setSavedValue(value)}
                        style={{width:"100%"}}
                    />
                    
                </div>
                {savedLoading && <LinearProgress sx={{
                            '& .MuiLinearProgress-bar': {
                            backgroundColor: '#005683',
                            },
                            backgroundColor: '#b1d1e1',
                        }}/>}
                <div className="text-end mt-2">
                    <Button disabled={savedLoading} className="ps-2 pe-2 me-2" style={{fontSize:"1rem"}} onClick={() => setShowSavedPaymentsWindow(false)}>{t("Cancel")}</Button>
                    <Button disabled={savedLoading} className="ps-2 pe-2" style={{fontSize:"1rem"}} onClick={onUnscheduledSavedClick}>{savedCardSelected?.value === -1 ? t(" Add New Card") : t("Pay")}</Button>
                </div>
            </div>
        </GenericModal>
        <GenericModal show={showNewPaymentWindow} onHide={() => setShowNewPaymentWindow(false)} title={t("Add funds")} icon={<PaymentIcon/>} size="md">
            <div style={{color:"var(--main-blue)"}}>
                <div className="fs-7 fw-bold mb-1">{t("Make a one time payment.")}</div>
                <div className="fs-8 mb-2">{t("This payment methods will not be saved to your account.")}</div>
                <div>
                    <CurrencyTextField
                        label="Amount to add"
                        variant="standard"
                        value={value}
                        currencySymbol="€"
                        disabled={addFundsLoading}
                        //minimumValue="0"
                        outputFormat="string"
                        decimalCharacter="."
                        digitGroupSeparator=","
                        onChange={(event, value)=> setValue(value)}
                        style={{width:"100%"}}
                    />
                    
                </div>
                {addFundsLoading && <LinearProgress sx={{
                            '& .MuiLinearProgress-bar': {
                            backgroundColor: '#005683',
                            },
                            backgroundColor: '#b1d1e1',
                        }}/>}
                <div className="d-flex mt-3">
                        <div className="d-flex">
                    <svg className="" stroke="currentColor" fill="currentColor" stroke-width="0" role="img" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M12.553 8.72v6.56h1.766v-1.694h1.052l.293-.01c.579-.009.907-.02.984-.033.656-.086 1.09-.418 1.3-.994.106-.29.16-.769.16-1.434 0-.553-.049-.968-.145-1.243-.185-.524-.548-.871-1.09-1.04-.236-.074-.58-.111-1.031-.111zm6.79 0l-1.971 6.56h1.826l.317-1.134h2.36l.337 1.133H24l-1.995-6.558zm-9.339.031a3.36 3.36 0 0 0-1.888.574 3.272 3.272 0 0 0-1.199 1.455h-.742l-.464.996h.969a3.17 3.17 0 0 0 .004.526h-.467l-.465.995H6.94a3.333 3.333 0 0 0 3.064 1.973 3.37 3.37 0 0 0 1.876-.564l.013-.009v-1.241l-.05.056a2.293 2.293 0 0 1-3.618-.215h2.396l.465-.995H7.838a2.356 2.356 0 0 1-.012-.526h3.505l.008-.017.438-.939.019-.04H8.154a2.308 2.308 0 0 1 1.963-1.108c.694 0 1.344.31 1.783.85l.028.035.409-.875-.015-.014a3.359 3.359 0 0 0-2.318-.917zm-7.2.004c-.439 0-.837.016-1.196.048-.43.034-.785.15-1.062.348a1.082 1.082 0 0 0-.41.565c-.086.248-.128.578-.128.99 0 .54.079.943.236 1.21.179.314.537.52 1.074.621.205.035.57.071 1.094.109.654.044 1.02.078 1.098.103.211.063.316.239.316.528a1.1 1.1 0 0 1-.037.315.48.48 0 0 1-.298.287c-.084.032-.281.048-.589.048h-.604a.963.963 0 0 1-.41-.09c-.164-.081-.246-.264-.246-.549v-.136H0c0 .533.04.915.118 1.143.142.412.435.685.879.82.362.11 1.003.164 1.922.164.551 0 .96-.025 1.228-.075.64-.12 1.05-.404 1.233-.853.101-.245.151-.632.151-1.16 0-.23-.01-.435-.033-.617a1.186 1.186 0 0 0-.355-.74c-.252-.242-.66-.392-1.22-.448-.177-.019-.62-.052-1.33-.1l-.331-.023a.768.768 0 0 1-.35-.094c-.124-.075-.185-.233-.185-.471 0-.264.07-.435.208-.514.139-.079.423-.118.852-.118.441 0 .71.068.808.205.063.092.095.272.095.542h1.642c.01-.145.016-.253.016-.326 0-.884-.357-1.421-1.072-1.613-.293-.079-.784-.119-1.473-.119zm17.894 1.27l.827 2.843h-1.63zm-6.38.13h1.116c.18 0 .294.004.342.01.24.042.393.157.456.345.045.134.067.34.067.617a2.9 2.9 0 0 1-.033.512c-.035.172-.105.287-.21.344-.076.042-.288.069-.637.082h-1.1Z"></path></svg>
                    <svg className="ms-2" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 576 512" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M125.61,165.48a49.07,49.07,0,1,0,49.06,49.06A49.08,49.08,0,0,0,125.61,165.48ZM86.15,425.84h78.94V285.32H86.15Zm151.46-211.6c0-20-10-22.53-18.74-22.53H204.82V237.5h14.05C228.62,237.5,237.61,234.69,237.61,214.24Zm201.69,46V168.93h22.75V237.5h33.69C486.5,113.08,388.61,86.19,299.67,86.19H204.84V169h14c25.6,0,41.5,17.35,41.5,45.26,0,28.81-15.52,46-41.5,46h-14V425.88h94.83c144.61,0,194.94-67.16,196.72-165.64Zm-109.75,0H273.3V169h54.43v22.73H296v10.58h30V225H296V237.5h33.51Zm74.66,0-5.16-17.67H369.31l-5.18,17.67H340.47L368,168.92h32.35l27.53,91.34ZM299.65,32H32V480H299.65c161.85,0,251-79.73,251-224.52C550.62,172,518,32,299.65,32Zm0,426.92H53.07V53.07H299.65c142.1,0,229.9,64.61,229.9,202.41C529.55,389.57,448.55,458.92,299.65,458.92Zm83.86-264.85L376,219.88H392.4l-7.52-25.81Z"></path></svg>
                    <svg className="ms-2" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" class="w-5 h-5" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><g id="Bank"><path d="M19.505,17.943V10.362a1.491,1.491,0,0,0,1.39-1.12,1.468,1.468,0,0,0-.7-1.68l-7.45-4.3a1.521,1.521,0,0,0-1.49,0l-7.45,4.3a1.468,1.468,0,0,0-.7,1.68,1.487,1.487,0,0,0,1.45,1.12h.13v7.57h-.12a1.5,1.5,0,0,0,0,3h14.87a1.5,1.5,0,0,0,.07-2.989ZM4.555,9.362a.505.505,0,0,1-.25-.94l7.45-4.289a.474.474,0,0,1,.49,0L19.7,8.422a.5.5,0,0,1-.25.94Zm13.95,1v7.57H14.9v-7.57Zm-4.61,0v7.57h-3.61v-7.57Zm-4.61,0v7.57h-3.6v-7.57Zm10.15,9.57H4.565a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h14.87a.5.5,0,0,1,.5.5A.5.5,0,0,1,19.435,19.932Z"></path></g></svg>
                    <svg className="ms-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" height="24" width="24" stroke="currentColor" aria-hidden="true" class="w-5 h-5"><path strokeLinecap="round" strokeLinejoin="round" d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5z"></path></svg>
                    <svg className="ms-2" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 640 512" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M105.72,215v41.25h57.1a49.66,49.66,0,0,1-21.14,32.6c-9.54,6.55-21.72,10.28-36,10.28-27.6,0-50.93-18.91-59.3-44.22a65.61,65.61,0,0,1,0-41l0,0c8.37-25.46,31.7-44.37,59.3-44.37a56.43,56.43,0,0,1,40.51,16.08L176.47,155a101.24,101.24,0,0,0-70.75-27.84,105.55,105.55,0,0,0-94.38,59.11,107.64,107.64,0,0,0,0,96.18v.15a105.41,105.41,0,0,0,94.38,59c28.47,0,52.55-9.53,70-25.91,20-18.61,31.41-46.15,31.41-78.91A133.76,133.76,0,0,0,205.38,215Zm389.41-4c-10.13-9.38-23.93-14.14-41.39-14.14-22.46,0-39.34,8.34-50.5,24.86l20.85,13.26q11.45-17,31.26-17a34.05,34.05,0,0,1,22.75,8.79A28.14,28.14,0,0,1,487.79,248v5.51c-9.1-5.07-20.55-7.75-34.64-7.75-16.44,0-29.65,3.88-39.49,11.77s-14.82,18.31-14.82,31.56a39.74,39.74,0,0,0,13.94,31.27c9.25,8.34,21,12.51,34.79,12.51,16.29,0,29.21-7.3,39-21.89h1v17.72h22.61V250C510.25,233.45,505.26,220.34,495.13,211ZM475.9,300.3a37.32,37.32,0,0,1-26.57,11.16A28.61,28.61,0,0,1,431,305.21a19.41,19.41,0,0,1-7.77-15.63c0-7,3.22-12.81,9.54-17.42s14.53-7,24.07-7C470,265,480.3,268,487.64,273.94,487.64,284.07,483.68,292.85,475.9,300.3Zm-93.65-142A55.71,55.71,0,0,0,341.74,142H279.07V328.74H302.7V253.1h39c16,0,29.5-5.36,40.51-15.93.88-.89,1.76-1.79,2.65-2.68A54.45,54.45,0,0,0,382.25,158.26Zm-16.58,62.23a30.65,30.65,0,0,1-23.34,9.68H302.7V165h39.63a32,32,0,0,1,22.6,9.23A33.18,33.18,0,0,1,365.67,220.49ZM614.31,201,577.77,292.7h-.45L539.9,201H514.21L566,320.55l-29.35,64.32H561L640,201Z"></path></svg>
                    <svg className="ms-2" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 640 512" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M116.9 158.5c-7.5 8.9-19.5 15.9-31.5 14.9-1.5-12 4.4-24.8 11.3-32.6 7.5-9.1 20.6-15.6 31.3-16.1 1.2 12.4-3.7 24.7-11.1 33.8m10.9 17.2c-17.4-1-32.3 9.9-40.5 9.9-8.4 0-21-9.4-34.8-9.1-17.9.3-34.5 10.4-43.6 26.5-18.8 32.3-4.9 80 13.3 106.3 8.9 13 19.5 27.3 33.5 26.8 13.3-.5 18.5-8.6 34.5-8.6 16.1 0 20.8 8.6 34.8 8.4 14.5-.3 23.6-13 32.5-26 10.1-14.8 14.3-29.1 14.5-29.9-.3-.3-28-10.9-28.3-42.9-.3-26.8 21.9-39.5 22.9-40.3-12.5-18.6-32-20.6-38.8-21.1m100.4-36.2v194.9h30.3v-66.6h41.9c38.3 0 65.1-26.3 65.1-64.3s-26.4-64-64.1-64h-73.2zm30.3 25.5h34.9c26.3 0 41.3 14 41.3 38.6s-15 38.8-41.4 38.8h-34.8V165zm162.2 170.9c19 0 36.6-9.6 44.6-24.9h.6v23.4h28v-97c0-28.1-22.5-46.3-57.1-46.3-32.1 0-55.9 18.4-56.8 43.6h27.3c2.3-12 13.4-19.9 28.6-19.9 18.5 0 28.9 8.6 28.9 24.5v10.8l-37.8 2.3c-35.1 2.1-54.1 16.5-54.1 41.5.1 25.2 19.7 42 47.8 42zm8.2-23.1c-16.1 0-26.4-7.8-26.4-19.6 0-12.3 9.9-19.4 28.8-20.5l33.6-2.1v11c0 18.2-15.5 31.2-36 31.2zm102.5 74.6c29.5 0 43.4-11.3 55.5-45.4L640 193h-30.8l-35.6 115.1h-.6L537.4 193h-31.6L557 334.9l-2.8 8.6c-4.6 14.6-12.1 20.3-25.5 20.3-2.4 0-7-.3-8.9-.5v23.4c1.8.4 9.3.7 11.6.7z"></path></svg>
                    {/* {!openedAddFunds && <Button className="ps-2 pe-2 ms-auto" style={{fontSize:"1rem"}} onClick={() => setOpenedAddFunds(true)}>{t("Add funds")}</Button>} */}
                </div>
                    <div className="ms-auto">
                        <Button disabled={addFundsLoading} className="ps-2 pe-2 me-2" style={{fontSize:"1rem"}} onClick={() => setShowNewPaymentWindow(false)}>{t("Cancel")}</Button>
                        <Button disabled={addFundsLoading} className="ps-2 pe-2" style={{fontSize:"1rem"}} onClick={onAddFundsClick}>{t("Continue")}</Button>
                    </div>
                </div>
            </div>
        </GenericModal>
        </>);
};

export default Overview;
const Package = ({p, title, goToPackages, cancelPackage, icon,  ...prop}) => {
    const {t} = useTranslation();
    return (
        <div className={classes.packageSelected} {...prop}>
            <div className="d-flex">
                <h5>{icon}{title}</h5>
                <div className="ms-auto">
                    {/* {!p.Trial && <Button className="ps-2 pe-2" onClick={() => cancelPackage(p)}>{t("Cancel")}</Button>} */}
                </div>
            </div>
            <ul>
                <li>{t("Package")}: <span className={classes["main-orange"]}>{p?.PackageCode}</span></li>
                <li>{t("Pay type")}: <span className={classes["main-orange"]}>{p?.PayType}</span></li>
                <li>{t("Price")} : <span className={classes["main-orange"]}>{p?.PayType === "Monthly" ? p?.PricePerMonth	: p?.PricePerYear}€</span></li>
                {p.Trial && p.ValidDaysLeft >= 0 && <li>{t("Days left")}: <span className={classes["main-orange"]}>{p.ValidDaysLeft}</span></li>}
            </ul>
            {p.Trial && p.ValidDaysLeft < 0 && <div className={classes["main-orange"]}>{t("Trial has expired, if you wish to select a package")} <span className={classes["go-to-packages"]} onClick={() => goToPackages(p)}>{t("click here")}.</span></div>}
            
        </div>
    );
}

const CheckoutStatus = ({checkoutId, onCompleted}) => {
    const {t} = useTranslation();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState();
    const [count, setCount] = useState(0);
    const [data, setData] = useState();
    const [completed, setCompleted] = useState(false);

    useInterval(() => {
        if(!checkoutId) return;
        if(completed) return;
        ddd.Rpc_ExecuteExtension("EUeInvoices.GetCheckoutTransactionStatus", {"type": "transactionsByCheckout","Id": checkoutId}).then(res => {
            if(!res?.result) return;
            setCount(res?.result?.count||0)
            let _data = res?.result?.data;
            if(!_data) return;
            for(let i = 0; i < _data.length; i++){
                if(_data[i].Response){
                    try{
                        _data[i].ResponseJS = JSON.parse(_data[i].Response);
                    }catch(e){
                    }
                }  
            }
            setData(_data);
            if(isPaymentCredited(_data[0]) || isPaymentCompleted(_data[0])){
                setLoading(false);
                setCompleted(true);
                if(onCompleted) setTimeout(() => onCompleted(), 5000);
            }
            if(isPaymentError(_data[0])){
                setLoading(false);
                setError(isPaymentError(_data[0]));
                if(onCompleted) setTimeout(() => onCompleted(), 10000);
            }
        }).catch(err => {
            setLoading(false);
            setError(t("An unknown error occured"));
        });
    }, 5000);

    const isPaymentCredited = (d) => {
        return d?.Credited === true;
    }

    const isPaymentCompleted = (d) => {
        switch(d?.latestTransactionType){
            case "AUTHORIZATION":
                return d?.status==="AUTHORIZED";
            case "CAPTURE":
                return d?.status==="INITIATED" || d?.status==="SETTLED" || d?.status==="PAID_OUT" || d?.status==="CAPTURED";
            default:
                return false;
        }
    }

    const isPaymentError = (d) => {
        switch(d?.status){
            case "DECLINED":
                return t("Payment was declined");
            case "CANCELLED":
                return t("Payment was cancelled");
            case "ERROR":
                return t("Payment failed");
            case "POSSIBLE_FRAUD":
                return t("Payment was marked as possible fraud");
            default:
                return false;
        }
    }

    const getPaymentStatusIcon = (d) => {
        if(isPaymentCredited(d)) return <CheckCircleIcon className={classes["main-green"]}/>
        if(isPaymentCompleted(d)) return <CheckCircleIcon className={classes["main-green"]}/>
        if(isPaymentError(d)) return <ErrorIcon className={classes["main-red"]}/>
        return <HourglassBottomIcon />;
    }

    const getPaymentMethod = (d) => {
        for(let i = 0; i < d?.ResponseJS?.children?.length; i++){
            if(d?.ResponseJS?.children[i]?.transactionVariant)
                return d?.ResponseJS?.children[i]?.transactionVariant;
        }
        return null;
    }

    return (
        <div class="alert alert-primary mt-2" role="alert">
            {loading && <LinearProgress sx={{
                            '& .MuiLinearProgress-bar': {
                            backgroundColor: '#005683',
                            },
                            backgroundColor: '#b1d1e1',
                        }}/>}
            <div className="mb-2">{t("Processing payment")} {count > 1 && <>{t("(Multiple transactions seem to have taken place")}: {count+')'}</>}</div>
            {data?.map((d, index) => {
                return(<div className="d-flex fs-7">
                    <div>{t("Payment method")}: {getPaymentMethod(d)}</div>
                    <div className="ms-auto">{getPaymentStatusIcon(d)}  </div>
                </div>)
            })}
            {error && <div>{error}</div>}
        </div>
    );
};

const CheckoutUscheduledStatus = ({checkoutId, onCompleted}) => {
    const {t} = useTranslation();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState();
    const [data, setData] = useState();
    const [completed, setCompleted] = useState(false);

    useInterval(() => {
        if(!checkoutId) return;
        if(completed) return;
        ddd.Rpc_ExecuteExtension("EUeInvoices.GetCheckoutTransactionStatus", {"type": "checkout","Id": checkoutId}).then(res => {
            if(!res?.result || res?.result?.count===0) return;
            let _data = res?.result?.data[0];
            if(!_data) return;
            try{
                _data.ResponseJS = JSON.parse(_data.Response);
            }catch(e){
            }
            setData(_data);

            if(isComplete(_data)){
                setLoading(false);
                setCompleted(true);
                if(onCompleted) setTimeout(() => onCompleted(), 5000);
            }
            if(isErrored(_data)){
                setLoading(false);
                setError(isErrored(_data));
                setCompleted(true);
                if(onCompleted) setTimeout(() => onCompleted(), 10000);
            }
        }).catch(err => {
            setLoading(false);
            setError(t("An unknown error occured"));
        });
    }, 5000);

    const isPaymentCredited = (d) => {
        return d?.Credited === true;
    }

    const latestCheckout = (d) => {
        return d?.ResponseJS?.events && [...d.ResponseJS.events].reverse().find(e => e.resourceType === "CHECKOUT");
    }
    const latestTX = (d) => {
        return d?.ResponseJS?.events && [...d.ResponseJS.events].reverse().find(e => e.resourceType === "TX");
    }
    const latestThreeds = (d) => {
        return d?.ResponseJS?.events && [...d.ResponseJS.events].reverse().find(e => e.resourceType === "THREEDS");
    }
    const isComplete = (d) => {
        return d?.ResponseJS?.events?.find(e => e.resourceType === "TX" && e.status === "AUTHORIZED");
    }
    const isErrored = (d) => {
        return d?.ResponseJS?.events?.find(e => e.resourceType === "TX" && (e.status === "DECLINED" || e.status === "ERROR"));
    }

    const getStatus = (d) => {
        console.log(d);
        console.log(latestTX(d));
        if(latestTX(d)) return t("Transaction status")+": "+latestTX(d).status;
        if(latestThreeds(d)) return t("3D secure status")+": "+latestThreeds(d).status;
        if(latestCheckout(d)) return t("Checkout status")+": "+latestCheckout(d).status;
        return t("Unknown status");
    }

    const getPaymentStatusIcon = (d) => {
        if(isComplete(d)) return <CheckCircleIcon className={classes["main-green"]}/>
        if(isErrored(d)) return <ErrorIcon className={classes["main-red"]}/>
        return <HourglassBottomIcon />;
    }

    return (
        <div class="alert alert-primary mt-2" role="alert">
            {loading && <LinearProgress sx={{
                            '& .MuiLinearProgress-bar': {
                            backgroundColor: '#005683',
                            },
                            backgroundColor: '#b1d1e1',
                        }}/>}
            <div className="mb-2">{t("Please wait while the authenticate the payment")}</div>
            {data && <div className="d-flex fs-7">
                <div>{getStatus(data)}</div>
                <div className="ms-auto">{getPaymentStatusIcon(data)}</div>
            </div>}
            {error && <div>{error}</div>}
        </div>
    );
};
